module.exports = __webpack_public_path__ + "img/soln-meta-lorem.6ca3b0a9.jpg";